import './meal_detail.css'

import React, { useState, useRef, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useAuth } from '../../Components/AuthContext/AuthContext'
import { get, post } from '../../Services/api';
import { AiFillLike, AiFillDislike } from "react-icons/ai";
import { FaBookmark } from "react-icons/fa";
import Carousel from '../../Components/Carousel/Carousel';
import BeanButtonNext from '../../Components/Buttons/BeanButton/BeanButtonNext/BeanButtonNext';
import BeanButtonPrev from '../../Components/Buttons/BeanButton/BeanButtonPrev/BeanButtonPrev';
import NutritionChart from './NutritionChart';
import edit_meal_open from '../../Utility/edit_meal_open';
import { MdDelete } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { RiGitRepositoryPrivateFill } from "react-icons/ri";
import AddMeal from '../AddMeal/AddMeal';
import { Tooltip } from 'react-tooltip'
import NTAIWidget from '../../Components/NTAIWidget/NTAIWidget';

function MealDetail({ setEditMeal }) {
    const { mealId } = useParams();
    const [meal, setmealDetail] = useState(null);
    const [openAddMeal, setOpenAddMeal] = useState(false);

    const [n_similar_items_to_show, set_n_similar_items_to_show] = useState(0);
    const navigate = useNavigate();

    const { currentUser } = useAuth();
    const sliderRef = useRef(null);


    useEffect(() => {
        getMealDetail()
    }, [mealId]);

    useEffect(() => {
        updateWidth()
    }, []);


    const updateWidth = () => {
        var similarMeals = document.getElementById('meal_details_similar_meals');
        if (similarMeals != undefined) {
            let number_items_allowed = similarMeals.getBoundingClientRect().width / 350;
            number_items_allowed = Math.round(number_items_allowed)
            set_n_similar_items_to_show(number_items_allowed)
        } else {
            set_n_similar_items_to_show(2)
        }
    };

    async function deactivate_meal() {
        if (window.confirm('Are you sure you want to delete this meal? This action cannot be undone.')) {
            try {
                const today = new Date().toLocaleDateString('en-CA');
                await post("/api/meal/user-deactivate-meal", {
                    meal_id: mealId,
                    user_id: currentUser.uid,
                    current_date: today
                });
                navigate(`/`);
            } catch (error) {
                console.error('Failed to deactivate meal:', error);
                alert('An error occurred while deactivating the meal. Please try again.');
            }
        }
    }


    useEffect(() => {
        updateWidth()
    }, [sliderRef.current])

    useEffect(() => {


        // Add event listener for window resize
        window.addEventListener('resize', updateWidth);

        // Cleanup on component unmount
        return () => {
            window.removeEventListener('resize', updateWidth);
        };
    }, [meal]);

    async function getMealDetail() {
        try {
            const result = await get("/api/meal/get-meal-detail", { meal_id: mealId, user_id: currentUser.uid });

            const similarMeals = await get('api/meal/get-similar-meals', {
                user_id: currentUser.uid,
                coursesIds: result.courses,
                cuisinesIds: result.cuisines,
                parent_id: result.parent_meal_id,
                meal_id: mealId
            })
            result.similar_meals = similarMeals;
            result.isSnack = result.courses.includes(8)
            setmealDetail(result)
        } catch (e) {
            navigate('/404')
        }
    }

    async function userLikeMeal() {
        try {
            await post("/api/meal/user-like-meal", { meal_id: mealId, user_id: currentUser.uid })
            // Get meals again
            await getMealDetail()
        } catch {
            alert("An error occured while liking meal")
        }
    }
    async function userDislikeMeal() {
        try {
            await post("/api/meal/user-dislike-meal", { meal_id: mealId, user_id: currentUser.uid })
            // Get meals again
            await getMealDetail()
        } catch {
            alert("An error occured while disliking meal")
        }
    }

    async function userFavoriteMeal() {
        try {
            await post("/api/meal/user-favorite-meal", { meal_id: mealId, user_id: currentUser.uid })
            // Get meals again
            await getMealDetail()
        } catch {
            alert("An error occured while favoriting meal")
        }
    }

    return (
        meal && < div className='meal_details_parent_div' >
            {
                openAddMeal && <AddMeal selectedMeal={meal} modalOpen={openAddMeal} setModalOpen={setOpenAddMeal} />

            }
            <div className='meal_details_first_div'>
                <h2 className='font_family_ovo'>
                    {
                        meal.name
                    }
                </h2>
                <div className='meal_details_first_div_bottom'>

                    <div className='meal_details_first_div_left_child'>

                        <div className='meal_details_first_div_left_child_actions'>

                            <div className='meal_details_first_div_left_child_stats'>
                                <div className='meal_details_first_div_left_child_stats_indiv'>
                                    <p className='meal_details_first_div_left_child_stats_indiv_number font_family_ovo font_weight_400'>
                                        {meal.ingredient.length}
                                    </p>
                                    <p className='font_size_16 font_weight_400 font_family_inter gray_scale_3'>
                                        Ingredients
                                    </p>
                                </div>
                                <div className='meal_details_first_div_left_child_stats_indiv'>
                                    <p className='meal_details_first_div_left_child_stats_indiv_number font_family_ovo  font_weight_400'>
                                        {meal.time_to_make}
                                    </p>
                                    <p className='font_size_16 font_weight_400 font_family_inter gray_scale_3'>
                                        Minutes
                                    </p>
                                </div>
                                <div className='meal_details_first_div_left_child_stats_indiv'>
                                    <p className='meal_details_first_div_left_child_stats_indiv_number font_family_ovo font_weight_400'>
                                        {
                                            meal.total_calories
                                        }
                                    </p>
                                    <p className='font_size_16 font_weight_400 font_family_inter gray_scale_3'>
                                        Calories
                                    </p>
                                </div>
                            </div>

                            <div className='meal_details_first_div_left_child_actions_buttons'>
                                <div className='flex flex_wrap gap_16'>

                                    <div className={'meal_details_first_div_action_button' + (meal.is_liked === true ? ' meal_details_first_div_action_button_active' : '')} onClick={() => userLikeMeal()}>
                                        <AiFillLike size={20} color={meal.is_liked === true ? '#235539' : '#C5C1B9'} />
                                    </div>
                                    <div className={'meal_details_first_div_action_button' + (meal.is_liked === false ? ' meal_details_first_div_action_button_active' : '')} onClick={() => userDislikeMeal()}>
                                        <AiFillDislike size={20} color={meal.is_liked === false ? '#235539' : '#C5C1B9'} />
                                    </div>
                                    <div className={'meal_details_first_div_action_button' + (meal.is_favorite === true ? ' meal_details_first_div_action_button_active' : '')}
                                        onClick={() => userFavoriteMeal()}
                                    >
                                        <FaBookmark size={18} color={meal.is_favorite === true ? '#235539' : '#C5C1B9'} />
                                    </div>
                                </div>

                                <div className='flex gap_16 flex_wrap align_start'>
                                    <div className='green_solid_button flex align_center gap_6 white green_gradient font_size_14 font_family_inter font_weight_600' onClick={() => {
                                        setOpenAddMeal(true)
                                    }}>
                                        <span>
                                            +
                                        </span>
                                        <span >
                                            Add To My Plan
                                        </span>
                                    </div>
                                    <div className='green_outlined_button green_gradient_p font_size_14 font_family_inter font_weight_600' onClick={() => edit_meal_open({ meal_id: mealId, setEditMeal: setEditMeal })}>
                                        {
                                            meal.user_create_id === currentUser.uid ? "Edit Meal" : 'Customize Meal'
                                        }

                                    </div>
                                    {
                                        meal.user_create_id === currentUser.uid && <div className='red_outlined_button red_gradient_p font_size_14 font_family_inter font_weight_600' onClick={() => deactivate_meal()}>
                                            <MdDelete size={20} color='#552323' />
                                            {meal.parent_meal_id ? 'Revert Meal' : 'Delete Meal'}
                                        </div>
                                    }

                                </div>
                            </div>

                        </div>

                    </div>
                    <div className='meal_details_image_container'>

                        <img className='meal_details_image' src={meal.image} />
                        <div style={{
                            position: 'absolute',
                            top: '10px',  // Adjust as needed
                            left: '10px', // Adjust as needed
                            fontSize: '24px', // Adjust size if necessary
                        }}
                            data-tooltip-id="private-meal-tooltip" data-tooltip-content={meal.user_create_id ?
                                (meal.parent_meal_id ? 'Adjusted Meal' : 'Made by You') : null}
                        >
                            {

                                meal.private && <div className='meal_slider_item_lock_icon'>
                                    <RiGitRepositoryPrivateFill color='#FFCB9E' />
                                </div>
                            }

                        </div>
                        <Tooltip id="private-meal-tooltip" />
                    </div>

                </div>

            </div >

            <div className='flex flex_wrap gap_20 meal_details_second_div'>
                <div className={'meal_details_second_div_nutritional_information' + (meal.isSnack ? '_singular' : '')}>
                    <p className='font_size_24 font_family_ovo font_weight_400 gray_scale_6'>Nutritional Information</p>
                    <div className={'meal_details_second_div_nutritional_information_bottom'}>

                        <div className='meal_details_second_div_nutritional_information_left_detail'>
                            <div className='meal_details_second_div_nutritional_information_left_indiv_detail'>
                                <div className='flex gap_8 align_center'>
                                    <div className='meal_details-graph-carb-icon'></div>
                                    <p className='font_weight_600 gray_scale_2'>Carb</p>
                                </div>
                                <p className='font_weight_600 gray_scale_2'>{meal.total_carb} g</p>
                            </div>
                            <div className='meal_details_second_div_nutritional_information_left_indiv_detail'>
                                <div className='flex gap_8 align_center'>
                                    <div className='meal_details-graph-fat-icon'></div>
                                    <p className='font_weight_600 gray_scale_2'>Fat</p>
                                </div>
                                <p className='font_weight_600 gray_scale_2'>{meal.total_fat} g</p>
                            </div>
                            <div className='meal_details_second_div_nutritional_information_left_indiv_detail'>
                                <div className='flex gap_8 align_center'>
                                    <div className='meal_details-graph-fiber-icon'></div>
                                    <p className='font_weight_600 gray_scale_2'>Fiber</p>
                                </div>
                                <p className='font_weight_600 gray_scale_2'>{meal.total_fiber} g</p>
                            </div>
                            <div className='meal_details_second_div_nutritional_information_left_indiv_detail'>
                                <div className='flex gap_8 align_center'>
                                    <div className='meal_details-graph-protein-icon'></div>
                                    <p className='font_weight_600 gray_scale_2'>Protein</p>
                                </div>
                                <p className='font_weight_600 gray_scale_2'>{meal.total_protein} g</p>
                            </div>
                        </div>


                        {/* <div className='meal_details-ni-chart-parent-div'> */}
                        <div className='meal_details-ni-chart-div'>
                            <div >
                                <NutritionChart details={[
                                    { label: "Fat", unit: "grams", value: meal.total_fat },
                                    { label: "Carb", unit: "grams", value: meal.total_carb },
                                    { label: "Fiber", unit: "grams", value: meal.total_fiber },
                                    { label: "Protein", unit: "grams", value: meal.total_protein },
                                ]} />
                                <div className='meal_details-ni-chart-calorie-text text_align_center'>
                                    <p className='font_size_68 font_family_ovo gray_scale_1'>
                                        {
                                            meal.total_calories
                                        }
                                    </p>
                                    <p className='font_weight_600 font_size_20 gray_scale_3'>Calories</p>
                                </div>
                            </div>

                        </div>
                    </div>


                </div>
                {
                    !meal.isSnack &&
                    <div className='meal_details_second_div_child_ingredients'>
                        <p className='font_size_24 font_family_ovo font_weight_400 gray_scale_6'>Ingredients</p>
                        <p className='font_size_16 font_family_ovo font_weight_400 gray_scale_6'>Serving Size: {meal.serving_size}</p>
                        <hr color='#E0DCD1' />
                        <ul className='meal_details_ingredients_list'>
                            {
                                meal.ingredient.map((item, i) => {
                                    return (
                                        <li key={i} className='font_size_14 font_family_inter font_weight_400 gray_scale_2'>
                                            {item.amount + ' ' + (item.unit?.includes('piece') ? '' : item.unit) + (item.amount === 1 || item.unit?.includes('piece') ? '' : 's') + ' ' + item.name}
                                        </li>
                                    );
                                })
                            }
                        </ul>
                    </div>
                }

            </div>
            {
                !meal.isSnack && <div className='meal_details_instructions'>
                    <p className='font_size_24 font_family_ovo font_weight_400 gray_scale_6'>Instructions</p>
                    <hr color='#E0DCD1' />
                    <ol className='meal_details_instructions_list'>
                        {
                            meal.recipe.map((item, i) => {
                                return (
                                    <li key={i} className='font_size_14 font_family_inter font_weight_400 gray_scale_2'>
                                        {item.description}
                                    </li>
                                );
                            })
                        }
                    </ol>
                </div>
            }


            {
                // Show only if there was some similar meals 
                (meal.similar_meals.length > 0) &&
                <div className='meal_details_similar_meals' id='meal_details_similar_meals'>
                    <div className='flex justify_space_between'>
                        <p className='meal_details_similar_meals_title font_family_ovo font_weight_400 gray_scale_6'>Explore Similar Meals</p>
                        <div className='flex gap_12 align_center'>
                            <BeanButtonPrev onClick={() => sliderRef.current?.prev()} />
                            <BeanButtonNext onClick={() => sliderRef.current?.next()} />
                        </div>
                    </div>
                    <Carousel items={meal.similar_meals} nitemsToShow={n_similar_items_to_show} ref={sliderRef} />
                </div>
            }

            <br />




            {/*
            
            
            NTAI WIDGET COMMENTED OUT 
            
            
            */}

            {/* <NTAIWidget meal_id={mealId} user_id={currentUser.uid} /> */}

        </div >
    );
}

export default MealDetail;
